import { render, staticRenderFns } from "./inspiration-scanner-carousel.vue?vue&type=template&id=f0eb00f6"
import script from "./inspiration-scanner-carousel.vue?vue&type=script&lang=js"
export * from "./inspiration-scanner-carousel.vue?vue&type=script&lang=js"
import style0 from "./inspiration-scanner-carousel.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports